import uuid from 'react-uuid'

function guid() {
  return uuid()
}

export const securityHelper = {
  guid
}
